export default __webpack_public_path__ + "static/nc_territory.4d66365f73d925840bb4f6cb46f511dd.png";